import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ProfileFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 2.27c-5.37 0-9.73 4.36-9.73 9.73s4.36 9.73 9.73 9.73 9.73-4.36 9.73-9.73S17.37 2.27 12 2.27Zm0 4.03c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1-1.71 0-3.1-1.39-3.1-3.1 0-1.71 1.39-3.1 3.1-3.1Zm0 12.89c-1.77 0-3.4-.65-4.65-1.71a1.35 1.35 0 0 1-.48-1.04c0-1.8 1.46-3.24 3.26-3.24h3.74c1.8 0 3.26 1.44 3.26 3.24 0 .4-.18.78-.48 1.04A7.14 7.14 0 0 1 12 19.2v-.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ProfileFilled
